<template>
  <div class="advocate"  v-on:scroll="handleScroll(event)" style="  overflow: hidden;">
    <div id="homeside">
      <a href="https://www.facebook.com/kingstonecy1986/">
      <img src="./../assets/icon-fb/icon-fb-m.png"
            srcset="./../assets/icon-fb/icon-fb-m@2x.png 2x,
                   ./../assets/icon-fb/icon-fb-m@3x.png 3x"
            class="icon">
      </a>
      <a href="mailto:cs@kingstonecy.com.tw" target="_blank">      
        <img src="./../assets/icon-mail/icon-mail-m.png"
          srcset="./../assets/icon-mail/icon-mail-m@2x.png 2x,
                  ./../assets/icon-mail/icon-mail-m@3x.png 3x"
          class="icon"></a>
    </div>   
    <div class="container">    
        <div class="article">
        <h1 id="labeltext">熱銷建案</h1>
            <span class="photo-text" v-show="carouselId == pic.id"
              v-for="pic in carousel" :key="pic.id">{{pic.description}}</span>
        </div>
        <div class="about-photos">
          <div class="photo-container">
            <img v-show="carouselId == pic.id"
                :src="require(`@/assets/previouswork@2x/${pic.photo}.png`)"
                class="photo" v-for="pic in carousel" :key="pic.id">
          </div>
                <div class="dot-container">             
                  <span v-for="pic in carousel" @click="changecarousel(pic)"
                        :key="pic.id" :class="{dots: carouselId !== pic.id, dotsactive : carouselId == pic.id}"></span>
                </div>              
        </div>
      </div>
<svg xmlns="http://www.w3.org/2000/svg" 
     width="1280" height="370" viewBox="0 0 1280 370" v-if="width < 1600" style="margin-left: 80px; margin-top: -80px;z-index:30;">
    <path fill="none"  :class="'stroke '+ this.className_theLINE"  fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v155.21h1278v151.74H668.076V370"/>
</svg>
<svg xmlns="http://www.w3.org/2000/svg" 
     width="1680" height="420" viewBox="0 0 1680 420" v-else-if="(1600 <= width) && (width <= 1800)" style="margin-left: 80px; margin-top: -80px;z-index:30;">
    <path fill="none"  :class="'stroke '+ this.className_theLINE"  fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v205.21h1478v121.74H428.076V500"/>
</svg>
<svg xmlns="http://www.w3.org/2000/svg" 
     width="1920" height="590" viewBox="0 0 1920 590" v-else-if="1800 < width" style="margin-left: 80px; margin-top: -200px; z-index:30;">
    <path fill="none"  :class="'stroke '+ this.className_theLINE"  fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v334h1650v121.74H428.076V600"/>
</svg>
    <span :class="'subtitle '+this.subname">最新推案</span>
    <div :class="'build-container ' +this.componentbuildings">
     <buildingscomponent style="margin-top:7.5%; margin-bottom:-1%;"/>
    </div>  
  <svg xmlns="http://www.w3.org/2000/svg" width="1280" height="241" v-if="width < 1600" viewBox="0 0 1280 241"  style="margin-left: 220px; margin-top: -80px;z-index:30;">
    <path fill="none"  :class="'stroke '+ this.className_theLINE2" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v240h999"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="1680" height="241" v-else-if="(1600 <= width) && (width <= 1800)" viewBox="0 0 1680 241"  style="margin-left: 282px; margin-top: -80px;z-index:30;">
    <path fill="none"  :class="'stroke '+ this.className_theLINE2" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v240h1099"/>
  </svg>
  <svg xmlns="http://www.w3.org/2000/svg" width="1920" height="241" v-else-if="1800 < width" viewBox="0 0 1920 241"  style="margin-left: 358px; margin-top: -40px;z-index:30;">
    <path fill="none"  :class="'stroke '+ this.className_theLINE2" fill-rule="evenodd" stroke="#BBB" stroke-linecap="square" d="M1 0v240h1199"/>
  </svg>
      <h1 :id="this.third+'rdlabeltext'">歷年建案</h1> 
      <div :class="'yearbook '+this.yearbookactive">
       <img src="./../assets/yearpic/yearpic-new.png"
          class="yearpic">   
      </div>      
  </div>
  
</template>
 
<script>
import buildingscomponent from './../components/buildings_component.vue'
export default {
  components:{
    buildingscomponent
  },
  data(){
    return {    
      width:"",  
      carouselId: 1,
      carousel:[
        // {id:0,description:'金石站前湛',photo:'goldFront'},
        {id:1,description:'金石成大砌',photo:'big'},
        {id:2,description:'金石世築',photo:'world'},
        {id:3,description:'金石龍悅',photo:'dragon1'},
        {id:4,description:'金石喆學',photo:'db@2x'},
        {id:5,description:'金石雙響',photo:'zc@2x'},
        {id:6,description:'金石首品',photo:'sp@2x'},
        {id:7,description:'金石首品II',photo:'ii-2@2x'},
        {id:8,description:'金石首品II',photo:'ii-1@2x'},
        {id:9,description:'金石ＬＶ',photo:'lv@2x'},
        {id:10,description:'金石＋PLUS',photo:'plus@2x'},
      ],
      windowscrollY:"",
      third:'',
      className_theLINE:'',
      subname:'',
      componentbuildings:'',
      className_theLINE2:'',
      yearbookactive:''
      }
  },
  methods: {
      handleResize() {
        this.width = window.innerWidth;
        this.height = window.innerHeight;
      },
      handleScroll (event) {
        this.windowscrollY = window.scrollY
        //console.log(this.windowscrollY)
        if (this.windowscrollY > 160) {
            this.className_theLINE = 'theLINE'
            this.subname = 'subname'
            this.componentbuildings = 'componentbuildings'    
        }      
        if (this.windowscrollY > 1100) {
            this.className_theLINE2 = 'theLINE2'
        }
        if (this.windowscrollY > 1150) {
            this.third = 'thi'
            this.yearbookactive = 'yearbookactive'
        }        

      // else console.log('no')
      },
      changecarousel(pic){
        this.carouselId = pic.id
        //console.log(this.carouselId)
      },
      runningcarousel(){
          this.carouselId = this.carouselId + 1 
          if(this.carouselId== 8){
            this.carouselId = 1
          }
      },
      changeautoplay(photo){
        this.autoplayId = photo.id
        //console.log(this.autoplayId)
      },
      runningautoplay(){
          this.autoplayId = this.autoplayId + 1 
          if(this.autoplayId== 7){
            this.autoplayId = 1
          }
      },
  }, 
  created () {
      window.addEventListener('resize', this.handleResize)
      this.handleResize();
      window.addEventListener('scroll', this.handleScroll);
      this.interval = setInterval(() => this.runningcarousel(), 6500);
      this.interval = setInterval(() => this.runningautoplay(), 10000);
  },
  destroyed () {
      window.removeEventListener('resize', this.handleResize)    
      window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>
<style scoped>
.advocate{
  width: 100%;
  height: auto;
  margin:0;
}

#homeside, .article, .about-photos{
  display: inline-block;
}

#homeside{
  position:relative;
  text-align: center;
  float: left;
  width: 46px;
  height: auto;
  margin: 300px 120px 10px 48px;
}
.icon {
  position:relative;
  height: 28px;
  margin: 9px 18px;
  object-fit: contain;
}
.icon:hover{
  cursor: pointer;
}
.container{
  width: 100%;
  margin:  0;
 background-image: linear-gradient(343deg, #e6e6e662 27%, #ffffff53 53%, #ebebeb29 95%, #feffff 100%);
 padding: 2% 0 2% 0;
}

.article{
  width:25%;
  height:auto;
  margin: 0 0;
}


@keyframes show-draw{
    100% {
        opacity: 1;
        }
    }
#labeltext {
  text-align: right;
  width: 50%;
  height: auto;
  display: block;
  /* opacity: 0.84; */
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 2.7px;
  color: #a89a80;

  opacity: 0;
  animation: showtext 0.6s linear forwards;
  -webkit-animation: showtext 0.6s linear forwards;
  animation-delay: 0.4s;
	-webkit-animation-delay: 0.4s;
}


.photo-text{
  text-align: right;
  width: 50%;
  height: auto;
  display: block;
  font-size: 18px;
  font-weight: 300;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: 1.43px;
  color: #7d7d7d;
  opacity: 0;
  animation: showtext 0.6s linear forwards;
  -webkit-animation: showtext 0.6s linear forwards;
  animation-delay: 0.8s;
	-webkit-animation-delay: 0.8s;
}

@keyframes showtext{
    100% {
      opacity: 1;
      transform: translateY(4px);
        }
    }
.about-photos{
  width: 50%;
  height: auto;
  margin: 0 auto 0 auto;
  vertical-align: middle;
  opacity: 0;
  animation: showtext 1.4s ease-in-out forwards;
  -webkit-animation: showtext 1.4s ease-in-out forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
  /* background-image: linear-gradient(320deg, #c4c3c283, #dadad9 3%, #ebebeb 18%, #feffffa2, #ffffff); */
}
.photo-container{
  width: 100%;
  height: auto;
  /* overflow:hidden; */
}
@keyframes showupfoto{
  0%{opacity: 0.75}
  80%{opacity: 0.85}
  100%{opacity: 0.7}
}
.photo{
  width: 95%;
  height: 408px;
  /* object-fit: contain; */
  opacity: 0.75;
  margin-right: 50px;
  animation: showupfoto 6.5s ease-out forwards;
  -webkit-animation: showupfoto 6.5s ease-out forwards;
}
.photo:hover{  
  opacity: 1.0 !important; }

.dot-container{ 
  height:auto; width:100%;
  margin: 0% -6% 0% auto;
  text-align: right;
  vertical-align:middle;
  }
.dots{
  display: inline-block;
  padding: 2px;
  margin: 0% 1%;
  border-radius: 50%;
  border: solid 1px #d8d8d8;
  background-color: #d8d8d8;
}
.dotsactive{
  display: inline-block;
  padding: 2px;
  margin: 0% 1%;
  border-radius: 50%;
  background: #d0ad76;
  border: 1px solid #d0ad76;
}
.dots:hover, .dotsactive:hover{cursor: pointer;}

@keyframes circle-draw{
    100% {
        stroke-dashoffset: 0;
        }
    }

.stroke{
    stroke-dashoffset: 3500;
    stroke-dasharray: 3500;
}
.theLINE{
  animation: circle-draw 2.6s linear forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
  -webkit-animation: circle-draw 2.6s linear forwards;
}
.theLINE2{
  animation: circle-draw 3s linear forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
  -webkit-animation: circle-draw 3s linear forwards;
}
@keyframes showup{
    0%{
      transform: translateY(14px);
    }
    100% {
        opacity: 1;
        }
    }
.build-container{ 
  width: 100%;
  height: auto;
  opacity: 0;}
.componentbuildings{
  animation: showup 1.4s ease-in-out forwards;
  -webkit-animation: showup 1.4s ease-in-out forwards;
  animation-delay: 1.4s;
	-webkit-animation-delay: 1.4s;
}
.subtitle {
  width: 60%;
  height: auto;
  opacity: 0.84;
  font-size: 28px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: 3px;
  color: #a89a80;
  display: block;
  margin: -11.5% 0 0 80%;
}
.subname{
  opacity: 0;
  animation: show-draw 0.6s linear forwards;
  -webkit-animation: show-draw 0.6s linear forwards;
  animation-delay: 0.65s;
	-webkit-animation-delay: 0.65s;
}
.yearbook{
  width:100%;
  height: auto;
  text-align: center;
  opacity: 0;
}
.yearbookactive{
  animation: showtext 1.4s ease-in-out forwards;
  -webkit-animation: showtext 1.4s ease-in-out forwards;
  animation-delay: 1s;
	-webkit-animation-delay: 1s;
}
.yearpic{
  width: 80%;
  height: auto;
  margin: 3% auto;
}
 #rdlabeltext{
  width: 124px;
  height: 24px;
  padding: 3% 5%;
  z-index:30;
  position:relative;
  margin: -5% auto 3% auto;
  background: #ffffff;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 3px;
  color: #a89a80;
  opacity: 0;
}
#thirdlabeltext{
  width: 124px;
  height: 24px;
  padding: 3% 5%;
  z-index:30;
  position:relative;
  margin: -5% auto 3% auto;
  background: #ffffff;
  font-size: 28px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: 3px;
  color: #a89a80;
  opacity: 0;
  animation: show-draw 0.45s linear forwards;
  -webkit-animation: show-draw 0.45s linear forwards;
  animation-delay: 0s;
	-webkit-animation-delay: 0s;
}
@media screen and (min-width:1600px) and (max-width:1800px){
.subtitle {
  margin: -10.5% 0 0 80%;
}
.yearpic{
  width: 70%;
  height: auto;
  margin: 5% auto 10% auto;
}
}
@media screen and (min-width:1801px){
.container{
  margin: 3% 0;
  padding: 2% 0 5% 0;
}
.article{
  margin: 0 3% 0 5%;
}
.photo{
  width: 862px;
  height: 478px;
}
.dot-container{ 
  margin: 0% 0% 0% -10%;
  }
.build-container{ 
  width: 88%;
  height: auto;
  margin: 0 auto;
 }
.yearpic{
  width: 60%;
  height: auto;
  margin: 5% auto 14% auto;
}
}
</style>